import { UAParser } from 'ua-parser-js'

// TODO(WEB-3908): Switch to definition in packages/uniswap once fixed
const parser = new UAParser(navigator.userAgent)
const { name: platform } = parser.getOS()
export const isIOS = platform === 'iOS'
export const isAndroid = platform === 'Android'
